<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Homepages'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Homepages'
        };
    },

    computed: {
        labels() {
            return [
                {
                    value: 'campus.name',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        options() {
            return {
                searchInput: false
            };
        }
    },

    methods: {
        ...mapActions({
            getItems: 'homepages/index',
            deleteItem: 'homepages/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/homepages/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/homepages/add');
        }
    }
};
</script>
